import { Box, Modal, Typography } from "components";
import { AppColor } from "theme/app-color";
import React from "react";
import ErrorMessageRender from "pages/main/masterInsurancePlans/components/freelance/ErrorMessageRender";

interface ValidationFailedModalProps {
  versionName: string;
  errorsObj: Record<string, { error: boolean; subs: string[] }>;
  t: (key: string, options?: any) => string;
}

export const showValidationFailedModal = ({
  versionName,
  errorsObj,
  t,
}: ValidationFailedModalProps) => {
  Modal.alert({
    title:
      t("client.error.masterInsurancePlanPublishedValidationFailed.result") ||
      "Result",
    children: (
      <Box>
        <Typography variant="body1" color={AppColor["Other/Danger"]}>
          {t(
            "client.error.masterInsurancePlanPublishedValidationFailed.notReadyToPublish",
            {
              versionName,
            }
          ) || `Version ${versionName} is not ready to publish`}
        </Typography>
        <ErrorMessageRender errorsObj={errorsObj} t={t} />
      </Box>
    ),
    okButtonLabel:
      t("client.error.masterInsurancePlanPublishedValidationFailed.close") ||
      "Close",
    okButtonColor: AppColor["Primary/Primary"],
    okButtonVariant: "outlined",
  });
};
